import styled from 'styled-components';

export interface TextInterface {
    fontFamily?: string;
    fontWeight?: string;
    fontSize?: string;
    padding?: string;
    paddingLeft?: string;
    paddingRight?: string;
    paddingTop?: string;
    paddingBottom?: string;
    backgroundColor?: string;
    border?: string;
    borderBottom?: string;
    borderRight?: string;
    borderLeft?: string;
    borderTop?: string;
    borderRadius?: string;
    color?: string;
    margin?: string;
    marginBottom?: string;
    marginTop?: string;
    marginLeft?: string;
    marginRight?: string;
    textAlign?: string;
    width?: string;
    textTransform?: string;
    maxWidth?: string;
    textOverflow?: string;
}
export const Text = styled.div<TextInterface>`
    color: ${(props)=>props.color};
    font-family: ${(props)=>props.fontFamily};
    font-weight: ${(props)=>props.fontWeight};
    font-size: ${(props)=>props.fontSize ? props.fontSize :'1rem'};
    padding: ${(props)=>props.padding ? props.padding :'0px'};
    padding-left: ${(props)=>props.paddingLeft};
    padding-right: ${(props)=>props.paddingRight};
    padding-top: ${(props)=>props.paddingTop};
    padding-bottom: ${(props)=>props.paddingBottom};
    border-radius: ${(props)=>props.borderRadius};
    border: ${(props)=>props.border};
    border-top: ${(props)=>props.borderTop};
    border-bottom: ${(props)=>props.borderBottom};
    border-left: ${(props)=>props.borderLeft};
    border-right: ${(props)=>props.borderRight};
    background-color: ${(props)=>props.backgroundColor};
    margin: ${(props)=>props.margin};
    margin-bottom: ${(props)=>props.marginBottom};
    margin-left: ${(props)=>props.marginLeft};
    margin-top: ${(props)=>props.marginTop};
    margin-right: ${(props)=>props.marginRight};
    text-align: ${(props)=>props.textAlign};
    width: ${(props)=>props.width};
    text-transform: ${(props)=>props.textTransform};
    maxWidth: ${(props)=>props.maxWidth};
    textOverflow: ${(props)=>props.textOverflow};
`;